import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2aa1d512&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HorizontalEntityCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/HorizontalEntityCard/index.vue').default,NewsCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/NewsCard/index.vue').default,RouteCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/RouteCard/index.vue').default,ExcursionCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/ExcursionCard/index.vue').default,EventCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/EventCard/index.vue').default,PlaceCard: require('/srv/rir-platform/tourism/src/tourism-front/components/common/PlaceCard/index.vue').default,Scroller: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Scroller/index.vue').default,Button: require('/srv/rir-platform/tourism/src/tourism-front/components/common/Button/index.vue').default})
